import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}true-id`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const trueidApi = {
  getSystemMaintenanceConversation: (request) => {
    // pageid
    const { config } = request
    return instance().get(`/cms/maintenance-message`, config)
  },
  postSystemMaintenanceConversation: (request) => {
    const { config, data } = request
    return instance().post(`/cms/maintenance-bot`, data, config)
  },
  postAutoLogin: (request) => {
    const { data } = request
    return instance().post('/auto-login', data)
  }
}

export default trueidApi



// WEBPACK FOOTER //
// ./src/api/trueid.js